<template>
  <div class="UpdateItem">
    <div class="user">
      <img class="avatar" :src="require('@/assets/images/avatar_03.png')" />
      <div class="info">
        <div class="name">野原新之助</div>
        <div class="date">2021.11.1 11:56</div>
      </div>
    </div>
    <div class="textarea" @click="$emit('click')">今天天气真好！</div>
    <div class="imgWrap">
      <div
        class="item"
        v-for="item in 6"
        :key="item"
        @click="imgPreview"
      >
        <img class="img" :src="require('@/assets/images/image_02.png')" />
      </div>
    </div>
    <div class="record">
      <div class="item">
        <img class="icon" :src="require('@/assets/images/issue/icon_zan_01.png')" />
        <span>888</span>
      </div>
      <div class="item">
        <img class="icon" :src="require('@/assets/images/issue/icon_comment_01.png')" />
        <span>666</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  name: 'UpdateItem',
  methods: {
    imgPreview () {
      ImagePreview(['https://img01.yzcdn.cn/vant/apple-1.jpg']);
    }
  }
};
</script>

<style lang="less" scoped>
.UpdateItem {
  padding: 40px 26px;
  .user {
    display: flex;
    align-items: center;
    .avatar {
      width: 80px;
      height: 80px;
    }
    .info {
      height: 80px;
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .name {
        font-size: 28px;
        color: #333333;
      }
      .date {
        font-size: 24px;
        font-weight: 500;
        color: #999AAA;
      }
    }
  }
  .textarea {
    margin: 30px 0;
    font-size: 28px;
    font-weight: 500;
    color: #333444;
  }
  .imgWrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-bottom: 20px;
      width: 33.3%;
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        width: 218px;
        height: 166px;
        background: #FFFFFF;
        border: 2px solid #707070;
        border-radius: 8px;
      }
    }
  }
  .record {
    margin-top: 20px;
    display: flex;
    align-items: center;
    .item {
      margin-right: 48px;
      display: flex;
      align-items: center;
      .icon {
        width: 32px;
        height: 32px;
      }
      span {
        margin-left: 8px;
        font-size: 24px;
        font-weight: 500;
        color: #999AAA;
      }
    }
  }
}
</style>